import React from "react";
import ReactDOM from "react-dom";
import Alert from "@material-ui/lab/Alert";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import { createStyles, withStyles } from "@material-ui/core/styles";

import {
  Typography,
  Button,
  LinearProgress,
  Divider,
  Toolbar,
  Container
} from "@material-ui/core";

import "./styles.css";
import logo from "./logo-elastic-vertical-color.png";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      {" Elastic "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const BorderLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 10
    },
    bar: {
      backgroundColor: "#FEC514"
    }
  })
)(LinearProgress);

class NameForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: "info",
      msg: "null",
      disable_submit: false,
      show: false,
      show_progress: false,
      progress: 0
    };
    this.myChangeHandler = this.myChangeHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  pullStatusHandler = () => {
    setInterval(this.pullStatus, 1000);
  };

  pullStatus = () => {
    if (this.state.show_progress) {
      var data = {
        event_id: this.state.event_id
      };
      var url = new URL(
        "https://2uarkpt21f.execute-api.eu-central-1.amazonaws.com/default/ASA-get-status"
      );
      Object.keys(data).forEach((key) =>
        url.searchParams.append(key, data[key])
      );
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data["progress"] < 100) {
            this.setState({
              progress: data["progress"],
              msg: data["msg"]
            });
          } else {
            this.setState({
              show_progress: false,
              disable_submit: false,
              alert: "success",
              msg: "The sources have been uploaded"
            });
          }
        });
    }
  };

  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;
    this.setState({
      [nam]: val
    });
  };

  handleSubmit(event) {
    event.preventDefault();
    var data = {
      endpoint: this.state.endpoint,
      access_token: this.state.access_token,
      key_employees: this.state.key_employees,
      key_issues: this.state.key_issues,
      key_trello: this.state.key_trello
    };
    var url = new URL(
      "https://op23uh5pja.execute-api.eu-central-1.amazonaws.com/default/WPS-request-handler"
    );
    console.log("start");
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    };
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        var response_code = data["status"];
        this.setState({ event_id: data["event_id"] });
        var messages = {
          "1": "Analytics is being updated"
        };
        this.setState({
          show: true,
          show_progress: response_code === 1,
          disable_submit: response_code === 1,
          alert: response_code === 1 ? "info" : "error",
          msg: messages[response_code]
        });
        console.log(data);
        if (response_code === 1) {
          this.pullStatusHandler();
        }
      })
      .catch((error) => {
        this.setState({
          show: true,
          alert: "error",
          msg: "An error occured"
        });
        console.log("Request failed", error);
      });
    console.log("finish");
  }

  render() {
    return (
      <div>
        <Toolbar position="static" className="Toolbar">
          <Typography component="h1" variant="6">
            Workplace Search Workshop - Connect Sources
          </Typography>
        </Toolbar>
        {this.state.show_progress ? (
          <BorderLinearProgress
            variant="determinate"
            value={this.state.progress}
          />
        ) : null}
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div>
            {this.state.show ? (
              <Alert severity={this.state.alert}> {this.state.msg} </Alert>
            ) : null}
            <form onSubmit={this.handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="endpoint"
                onChange={this.myChangeHandler}
                id="endpoint"
                label="Enterprise Search Endpoint"
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="access_token"
                onChange={this.myChangeHandler}
                label="Access Token"
                id="access_token"
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="key_employees"
                onChange={this.myChangeHandler}
                label="ID For Employees"
                id="key_employees"
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="key_issues"
                onChange={this.myChangeHandler}
                label="ID For Issues"
                id="key_issues"
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="key_trello"
                onChange={this.myChangeHandler}
                label="ID For Trello"
                id="key_trello"
              />
              <Alert severity="info"> By using this tool, you agree (i) not to use this tool in a production environment or (ii) in a non-production environment with production data. THIS TOOL IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, AND ELASTIC DISCLAIMS ALL LIABILITIES OF ANY KIND.
              </Alert>
              <Button
                disabled={this.state.disable_submit}
                type="submit"
                fullWidth
                style={{
                  backgroundColor: " #00bfb3",
                  color: "white"
                }}
                variant="contained"
              >
                Submit
              </Button>
            </form>
          </div>
          <Box mt={8}>
            <Copyright />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px"
              }}
            >
              <img src={logo} alt="Logo" width="50" height="60" />
            </div>
          </Box>
        </Container>
      </div>
    );
  }
}

ReactDOM.render(<NameForm />, document.getElementById("app"));



// WEBPACK FOOTER //
// ./src/index.js